// TextField.jsx
import { useState } from "react"
import { TextField as MuiTextField } from "@mui/material"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import { useApiService } from "../hooks/Api/useApiService"

const INVALID_CHARS_REGEX = /[<>{}"'`;/\\|&^%$#!=~\[\]{}]/g

const getInvalidChars = (text) => {
  const matches = text.match(INVALID_CHARS_REGEX)
  return matches ? [...new Set(matches)] : []
}

export default function TextField({ onChange, value, ...rest }) {
  const [internalValue, setInternalValue] = useState(value || "")
  const t = useTranslationSharie()
  const { postData } = useApiService()
  const [error, setError] = useState(null)
  const handleChange = (e) => {
    let inputValue = e.target.value
    const invalidChars = getInvalidChars(inputValue)

    if (invalidChars.length > 0) {
      // Display the error message
      setError({
        message: `${t("Invalid Character")}${
          invalidChars.length > 1 ? "s" : ""
        }: ${invalidChars.join(", ")}`,
        severity: "error",
      })

      // Auto-strip invalid characters
      inputValue = inputValue.replace(INVALID_CHARS_REGEX, "")
    } else {
      setError(null)
    }

    postData("ai/checkoffensive", { text: inputValue }).then((data) => {
      if (data.answer) {
        setError({ message: t("Offensive language detected!"), severity: "error" })
        onChange({ ...e, target: { ...e.target, value: null } })
        setInternalValue((prev) => prev.substring(0, prev.length - 2))
        return
      } else {
        setError(null)
        // Update internal value (this will trigger re-render)
      }
    })
    setInternalValue(inputValue)

    // Call the provided onChange handler with the sanitized value
    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: inputValue } })
    }
  }

  return (
    <T>
      <MuiTextField
        {...rest}
        value={internalValue}
        onChange={handleChange}
        error={!!error}
        helperText={error?.message || rest.helperText}
      />
    </T>
  )
}
